import * as React from 'react';
import { AutocompleterValue } from './Autocompleter';

export interface AutocompleterContextValues {
    selectedValue: AutocompleterValue | null;
    addSelection: ((value: AutocompleterValue, title: string) => void) | null;
    removeSelection: ((value: AutocompleterValue, title: string) => void) | null;
    isWaiting: boolean;
    multiSelect: boolean;
    searchTerm: string | null;
    setSearchTerm: React.Dispatch<React.SetStateAction<string | null>> | null;
    activeOptionId: string | null;
    setActiveOptionId: React.Dispatch<React.SetStateAction<string | null>> | null;
    activeOptionIndex: number | null;
    setActiveOptionIndex: React.Dispatch<React.SetStateAction<number | null>> | null;
    toggleOptionAtIndex: number | null;
    setToggleOptionAtIndex: React.Dispatch<React.SetStateAction<number | null>> | null;
    onFieldKeyDown: ((event: React.KeyboardEvent) => void) | null;
    scrollContext?: HTMLElement | null;
    inputRef: React.MutableRefObject<HTMLInputElement | null> | null;
    registerResultsList: ((element: HTMLElement) => void) | null;
    deregisterResultsList: ((element: HTMLElement) => void) | null;
}

export const AutocompleterContext = React.createContext<AutocompleterContextValues>({
    selectedValue: null,
    addSelection: null,
    removeSelection: null,
    isWaiting: false,
    multiSelect: false,
    searchTerm: null,
    setSearchTerm: null,
    activeOptionId: null,
    setActiveOptionId: null,
    activeOptionIndex: null,
    setActiveOptionIndex: null,
    toggleOptionAtIndex: null,
    setToggleOptionAtIndex: null,
    onFieldKeyDown: null,
    scrollContext: null,
    inputRef: null,
    registerResultsList: null,
    deregisterResultsList: null,
});
